// Inline edit directive — TRIAL ONLY (yalnız clinic-dashboard).
// İstifadə: <h1 v-tx="'ClinicDashboardWelcome'">{{ tx('ClinicDashboardWelcome') }}</h1>
// Edit mode aktiv olanda və user-in icazəsi varsa, elementin küncündə kiçik bir karandaş düyməsi göstərir.
// Düyməyə basanda qlobal event yayır → modal açılır.

import store from "@/store";

const BTN_CLASS = "tx-edit-btn";
const HOST_CLASS = "tx-edit-host";

function makeBtn(key) {
  const b = document.createElement("button");
  b.type = "button";
  b.className = BTN_CLASS;
  b.setAttribute("aria-label", `Edit ${key}`);
  b.title = key;
  b.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4z"/></svg>';
  b.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.dispatchEvent(new CustomEvent("tx-edit-open", { detail: { key } }));
  });
  return b;
}

function sync(el, key) {
  // Mövcud düyməni təmizlə
  const old = el.querySelector(`:scope > .${BTN_CLASS}`);
  if (old) old.remove();
  el.classList.remove(HOST_CLASS);

  if (!store.state.editMode || !key) return;

  // Host stillərini təmin et
  const cs = window.getComputedStyle(el);
  if (cs.position === "static") el.style.position = "relative";
  el.classList.add(HOST_CLASS);
  el.appendChild(makeBtn(key));
}

const watchers = new WeakMap();

export default {
  bind(el, binding) {
    sync(el, binding.value);
    // Reactively re-sync when editMode toggles
    const unwatch = store.watch(
      (s) => s.editMode,
      () => sync(el, binding.value)
    );
    watchers.set(el, unwatch);
  },
  update(el, binding) {
    sync(el, binding.value);
  },
  unbind(el) {
    const unwatch = watchers.get(el);
    if (unwatch) unwatch();
    watchers.delete(el);
  },
};
